import { ChangeEvent, ChangeEventHandler, JSX } from 'react';

export interface ValidatedInputProps {
    label: string;
    id: string;
    dataRecurly: string;
    placeholder: string;
    autoComplete: string;
    errorMessage?: string;
    onChange?: ChangeEventHandler<HTMLInputElement>;
}

export default function ValidatedTextInput({
    label,
    id,
    dataRecurly,
    placeholder,
    autoComplete,
    errorMessage,
    onChange = () => {},
}: ValidatedInputProps): JSX.Element {
    return (
        <div>
            <label htmlFor={id} className="block text-sm font-bold text-gray-900">
                {label}
            </label>
            <input
                id={id}
                name={id}
                data-recurly={dataRecurly}
                type="text"
                placeholder={placeholder}
                autoComplete={autoComplete}
                className="mt-1 block w-full border border-gray-700 rounded py-2 px-3 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 placeholder:text-gray-700"
                onChange={(event) => onChange(event)}
            />
            {errorMessage && <span className="text-sm font-bold text-red-500"> {errorMessage} </span>}
        </div>
    );
}
